/**
 * Product Description Helper Class
 */
'use strict';

const triggerEl = '.js-expand-description-link';
const descriptionEl = '.js-full-description';
const shortDescriptionEl = '.js-short-description';
const ellipsisEl = '.js-ellipsis';
const readMoreEl = '.js-read-more';
const readLessEl = '.js-read-less';
const isDesktopView = require('./modules/helpers/isDesktopView');

const bindEvents = () => {
    const isPG = $('.js-pdp-main').hasClass('giftset-pdp-main-container');
    if (!(isPG && isDesktopView())) {
        for (const el of $(triggerEl)) {
            $(el).on('click', onClickTrigger);
        }
    }
};

const onClickTrigger = (e) => {
    e.preventDefault();
   $(e.currentTarget).siblings(descriptionEl).toggleClass('hide');
   $(e.currentTarget).find(readLessEl).toggleClass('hide');
   $(e.currentTarget).find(readMoreEl).toggleClass('hide');
   $(e.currentTarget).siblings(ellipsisEl).toggleClass('hide');
   $(e.currentTarget).siblings(shortDescriptionEl).toggleClass('hide');
};

const shouldInit = () => {
    return $(triggerEl).length > 0;
};

module.exports = {
    init: () => {
        if (shouldInit()) {
            bindEvents();
        }
    }
};
